import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/api/config";

export type O360GroupEmployee = {
  id?: number | string;
  name?: string;
  last_name?: string;
  last_name_2?: string;
  birth_date?: string;
  birthDate?: string;
  fecha_nacimiento?: string;
  curp?: string;
  rfc?: string;
  sex?: string;
  sexo?: string;
  postal_code?: string;
  codigo_postal?: string;
  name_beneficiary?: string;
  last_name_beneficiary?: string;
  last_name_2_beneficiary?: string;
};

export type O360Group = {
  id: number | string;
  name: string;
  employees?: O360GroupEmployee[];
};

type O360GroupsState = {
  groups: O360Group[];
  loading: boolean;
};

export const getO360Groups = createAsyncThunk<
  { data: any },
  { clientId: number | string; params?: Record<string, any> }
>("o360/groups", async ({ clientId, params }) => {
  const response = await api.get(`api/employee_groups?client_id=${clientId}`, {
    params
  });
  return { data: response.data };
});

export const deleteO360Group = createAsyncThunk<
  { data: any },
  { groupId: number | string; clientId?: number | string }
>("o360/groups/delete", async ({ groupId, clientId }, { dispatch }) => {
  const response = await api.delete(`api/employee_groups/${groupId}`);
  if (clientId) {
    dispatch(getO360Groups({ clientId }));
  }
  return { data: response.data };
});

const initialState: O360GroupsState = {
  groups: [],
  loading: false
};

const o360GroupsSlice = createSlice({
  name: "o360Groups",
  initialState,
  reducers: {
    clearO360Groups: (state) => {
      state.groups = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getO360Groups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getO360Groups.fulfilled, (state, action) => {
      const payload = action.payload.data;
      const groups = Array.isArray(payload?.data?.data)
        ? payload.data.data
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.groups)
        ? payload.groups
        : Array.isArray(payload)
        ? payload
        : [];
      state.groups = groups;
      state.loading = false;
    });
    builder.addCase(getO360Groups.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { clearO360Groups } = o360GroupsSlice.actions;

export default o360GroupsSlice.reducer;
